






















































import { Vue, Component, Prop } from 'vue-property-decorator';

import CloseModalIcon from '@/components/icons/CloseModal.vue';
import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';
import NavButtonItem from '@/componentsV2/molecules/NavButtonItem/NavButtonItem.vue';
import BulkCheckboxes from '@/componentsV2/organisms/BulkCheckboxes/BulkCheckboxes.vue';
import OfferBulkCheckboxesItem from '@/componentsV2/molecules/OfferBulkCheckboxesItem/OfferBulkCheckboxesItem.vue';

import LocationsService from '@/api/LocationsService';

import { IOfferListItem } from '@/models/offer';

import eventBus from '@/utils/eventBus';

import HTTPStatus from '@/constants/httpStatus';

type TriggerPosition = 'header' | 'footer';

export interface OfferItem extends IOfferListItem {
  checked?: boolean;
}

interface IPayload {
  locationId: string;
  offerIds: string[];
}

@Component({
  components: {
    Typography,
    CloseModalIcon,
    FilledButton,
    NavButtonItem,
    OfferBulkCheckboxesItem,
    BulkCheckboxes
  }
})
export default class AddOffer extends Vue {
  @Prop() newLocationId?: string;
  @Prop() offers!: IOfferListItem[];

  observer: IntersectionObserver | null = null;
  triggerVisibility: Record<TriggerPosition, boolean> = {
    header: false,
    footer: false
  };

  locationService = new LocationsService({ disableToastMessage: true });
  loading = false;

  transformedOffers: OfferItem[] = this.formattedOffers();
  selectedOffers: OfferItem[] = this.formattedOffers();

  get componentToRender() {
    return OfferBulkCheckboxesItem;
  }

  get selectedOffersData() {
    return this.selectedOffers.map(item => item.id);
  }

  mounted() {
    this.handleTriggerObserver();
  }

  formattedOffers(): OfferItem[] {
    return this.offers.map(offer => ({
      ...offer,
      checked: true
    }));
  }

  onSubmit() {
    if (!this.selectedOffers.length || !this.newLocationId) {
      this.onClose();
      return;
    }

    const formattedData: IPayload = {
      locationId: this.newLocationId,
      offerIds: this.selectedOffersData
    };

    this.handleAssociateOffersToLocation(formattedData);
  }

  onClose() {
    eventBus.$emit('closeModal');
  }

  handleTriggerObserver() {
    this.observer = new IntersectionObserver(
      entries => {
        for (const entry of entries) {
          const position = entry.target.getAttribute(
            'data-position'
          ) as TriggerPosition;

          this.triggerVisibility[position] =
            !entry.isIntersecting && !!position;
        }
      },
      {
        root: document.querySelector('.add-offer-step'),
        rootMargin: '24px',
        threshold: 0
      }
    );

    const targets = document.querySelectorAll<HTMLElement>(
      '.add-offer-step__body-trigger'
    );

    for (const target of targets) {
      this.observer.observe(target);
    }
  }

  async handleAssociateOffersToLocation(payload: IPayload) {
    this.loading = true;
    const response = await this.locationService.associateOfferToLocation(
      payload
    );
    this.loading = false;

    if (response.status === HTTPStatus.CREATED) {
      this.$notification('New location with offers added successfully');
    }

    this.onClose();
  }
}
